import { sidebarData } from './sidebarData'

const EXCLUDED_SECTIONS = new Set([
    'customerPortal', 'supplierPortal', 'invitation',
    'joinOrganization', 'hello', 'resetPassword'
])

function flattenSection(items, app) {
    const result = []
    for (const item of items) {
        if (item.fastNav === false) continue
        if (item.subNav) {
            result.push(...flattenSection(item.subNav, app))
        } else if (item.path && item.title !== 'all.menu.backHome') {
            const path = item.path.startsWith('/') ? item.path : `/${item.path}`
            const key = `${app}-${item.title.replace(/\./g, '-')}`
            result.push({ key, title: item.title, path, app, icon: item.icon, desktopOnly: item.desktopOnly || false })
        }
    }
    return result
}

/**
 * The fast-nav entries of a sidebar model. A function, because the sidebar is
 * the org's resolved one (30.03.06 §3.2): callers pass getModel('sidebarData')
 * and memoize on the model version. It takes the sidebar rather than reading
 * the registry itself, which would import the registry into the very folder
 * the registry imports.
 */
export function getFastNavItems(sidebar) {
    return Object.entries(sidebar)
        .filter(([section]) => !EXCLUDED_SECTIONS.has(section))
        .flatMap(([section, items]) => flattenSection(items, section))
}

// The base list, for the linters that read the model maps (lint:txt). App code
// uses getFastNavItems(getModel('sidebarData')).
export const fastNavItems = getFastNavItems(sidebarData)
